/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);

    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      initMysteryGift();
    });

    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      initMysteryGift();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);


/* Mystery Gift Progress Bar */
function getMysteryGiftConfig() {
  const root = document.querySelector('[data-mystery-gift-progress]');
  if (!root) return null;

  const variantId = Number(root.dataset.mysteryGiftVariantId);
  const threshold = Number(root.dataset.mysteryGiftThreshold || 40000);

  if (!variantId) return null;

  return { root, variantId, threshold };
}

async function fetchMysteryCart() {
  const response = await fetch('/cart.js');
  return response.json();
}

function getSubtotalWithoutGift(cart, variantId) {
  return cart.items
    .filter((item) => item.variant_id !== variantId)
    .reduce((sum, item) => sum + item.final_line_price, 0);
}

async function removeMysteryGift(giftLine) {
  if (!giftLine) return;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: giftLine.key,
      quantity: 0
    })
  });

  document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
}

async function addMysteryGift(btn) {
  const config = getMysteryGiftConfig();
  if (!config) return;

  const { variantId } = config;

  if (btn) {
    btn.disabled = true;
    btn.textContent = 'מוסיף...';
  }

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
         'Gift': 'Mystery Gift',
          'Rule': 'Unlocked over ₪400'
        }
      }]
    })
  });

  document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
}

async function initMysteryGift() {
  const config = getMysteryGiftConfig();
  if (!config) return;

  const { root, threshold, variantId } = config;
  const cart = await fetchMysteryCart();

  const giftLine = cart.items.find((item) => item.variant_id === variantId);
  const subtotal = getSubtotalWithoutGift(cart, variantId);

  if (subtotal < threshold && giftLine) {
    await removeMysteryGift(giftLine);
    return;
  }

  const currentEl = root.querySelector('[data-mystery-current]');
  const fillEl = root.querySelector('[data-mystery-fill]');
  const messageEl = root.querySelector('[data-mystery-message]');
  const btnEl = root.querySelector('[data-add-mystery]');

  const progress = Math.min((subtotal / threshold) * 100, 100);
  const remaining = Math.ceil((threshold - subtotal) / 100);

  if (currentEl) currentEl.textContent = `₪${Math.floor(subtotal / 100)}`;
  if (fillEl) fillEl.style.width = `${progress}%`;

  if (subtotal >= threshold) {
    if (messageEl) {
      messageEl.textContent = giftLine
        ? '🎉 מתנת ההפתעה נוספה לעגלה'
        : '🎉 מתנת ההפתעה שלכם מחכה לכם!';
    }

    if (btnEl) {
      btnEl.style.display = giftLine ? 'none' : 'block';
      btnEl.disabled = false;
      btnEl.textContent = 'הוספת המתנה 🎁';
    }
  } else {
    if (messageEl) {
      messageEl.textContent = `רק עוד ₪${remaining} כדי לקבל את מתנת ההפתעה`;
    }

    if (btnEl) btnEl.style.display = 'none';
  }
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-add-mystery]');
  if (!btn) return;

  event.preventDefault();
  addMysteryGift(btn);
});

document.addEventListener('DOMContentLoaded', initMysteryGift);
document.addEventListener('dispatch:cart-drawer:refresh', () => {
  setTimeout(initMysteryGift, 500);
});